import axios from 'axios';

window.axios = axios;

// eslint-disable-next-line
const Rox = require('rox-browser');

export const StFeatureFlagController = Rox.default || Rox;
export const StFeatureFlagKey = process.env.VUE_APP_ROLLOUT_API_KEY;

/**
 * Flags
 */
const defaultProductionVersion = 'prod';
const defaultStagingVersion = 'staging';

const servicesToAddVersion = [
  'UserLegacy',
  'Auth',
  'WarRoom',
  'Performance',
  'Studio',
];

const BooleanFlagsAndDefaultValues = {
  showCompetitiveCards: false,
  shareDashboard: false,
  shareManagement: true,
  showImpressCards: false,
  showGlobalFilter: false,
  showBrandHealthCards: false,
  showStockCards: false,
  showDashboardExport: false,
  showImporter: false,
  showPDFImporter: false,
  showListeningAnotationLogs: false,
  showTextSearch: false,
  showUploadHistory: false,
  showNewCardMenu: false,
  showBlipComponents: false,
  showCustomComponents: false,
  showStudioDev: false,
  showAddCardShortcut: false,
  showComponentBuilder: false,
  showSacListeningComponents: false,
  showGPTSuggestionsComponents: false,
  hideStilingueGalleryAndFilters: false,
  showFilterTagTree: false,
  showChannelsByGroup: false,
  showGroupShare: false,
  showTagsShare: false,
  showThemesShare: false,
  showPNPTagsShare: false,
  showFilterSelection: false,
  showSentimentInTimePNP: false,
  showTagInTimePNP: false,
  showPostAndInteractionsIntime: false,
  showStudioPlus: false,
  showPolarityPieChartPNP: false,
  showImporterPostTags: false,
  showPostSamplingProjectionPNP: false,
  showTotalPostsSharesAndComments: false,
  showTotalPostsSharesAndCommentsInTime: false,
};

const StringFlagsAndDefaultValues = {
  publicDashboardInfo: '',
};

const FLAG_TYPE = {
  BOOLEAN: {
    KEY: 'BOOLEAN',
    CREATE_FLAG: (flagBoolean) => new StFeatureFlagController.Flag(flagBoolean),
  },
  STRING: {
    KEY: 'STRING',
    CREATE_FLAG: (flagString) => new StFeatureFlagController.RoxString(flagString),
  },
};

export const Flags = [];

export const StFeatureFlagFlags = {
  // Gateway controller
  gatewayProd: createConfiguration('https://secure-backend-api.stilingue.com.br/'),
  gatewayStaging: createConfiguration('https://secure-backend-api-staging.stilingue.com.br/'),
  getStagingPasskey: createConfiguration('2NVHxvwK2dXNndUFUDmCDBiWro8ITelCiizo6C0D'),
  getProdPasskey: createConfiguration('bGVzc2lzbW9yZWxlc3Npc21vcmVsZXNzaXNtb3Jl'),
};

/**
 * Add all services with Configuration Flags
 */
servicesToAddVersion.forEach(service => {
  const serviceProd = `${service}ServiceVersionProd`;
  const serviceStaging = `${service}ServiceVersionStaging`;
  StFeatureFlagFlags[serviceProd] = createConfiguration(defaultProductionVersion);
  StFeatureFlagFlags[serviceStaging] = createConfiguration(defaultStagingVersion);
});

/**
 * Create the flags according to your type
 * @param flagsAndDefaultValues Object with flags and their respective default values
 * @param flagKey Key value referring to the type of the flag
 */
function createFlags(flagsAndDefaultValues, flagKey) {
  const creatFlagFunction = FLAG_TYPE[flagKey].CREATE_FLAG;

  Object.keys(flagsAndDefaultValues).forEach((flag) => {
    StFeatureFlagFlags[flag] = creatFlagFunction(flagsAndDefaultValues[flag]);
    Flags[flag] = flag;
  });
}

function createConfiguration(configName) {
  return new StFeatureFlagController.RoxString(configName);
}

createFlags(BooleanFlagsAndDefaultValues, FLAG_TYPE.BOOLEAN.KEY);
createFlags(StringFlagsAndDefaultValues, FLAG_TYPE.STRING.KEY);

/**
 * Set the custom property in feature flag
 * @param key Searchable key, this key can be used to filter the access to the flag
 * @param value of this property
 */
function setCustomAttribute(key, value) {
  StFeatureFlagController.setCustomStringProperty(key, value);
}

export function insertRolloutMetadata({
  account_id,
  dashboard_id,
  universe_id,
  user_email,
  user_name,
  user_id,
  user_group,
} = {}) {
  // Should have Sentry installed and all user attributes
  const allAttributes = { account_id, dashboard_id, universe_id, user_email, user_name, user_id, user_group };
  if (Object.values(allAttributes).every(Boolean)) {
    for (const attr in allAttributes) {
      if (allAttributes.hasOwnProperty(attr)) {
        setCustomAttribute(`${attr}`, `${allAttributes[attr]}`);
      }
    }
    return true;
  }
  // If should install and do not have mandatory info
  console.error('It may be missing some mandatory info, check the following', allAttributes);
}

const alreadyShownFlagNotification = {};
const SENSITIVE_FLAGS = new Set([
  'gatewayProd',
  'gatewayStaging',
  'getStagingPasskey',
  'getProdPasskey',
  ...servicesToAddVersion.flatMap(service => [
    `${service}ServiceVersionProd`,
    `${service}ServiceVersionStaging`,
  ]),
]);

/**
 * Start Rollout
 */
StFeatureFlagController.register('default', StFeatureFlagFlags);
StFeatureFlagController.setup(StFeatureFlagKey, {
  freeze: 'none', // Update in real-time
  configurationFetchedHandler: (fetcherResults) => {
    if (fetcherResults.hasChanges) {
      console.info('[Feature Flag] Configuration fetched successfully with changes.');
    } else {
      console.info('[Feature Flag] Configuration fetched — no changes detected.');
    }
  },
  impressionHandler: (reporting) => {
    const flagLabel = reporting.name.replace(/^default\./u, '');
    if (!Object.prototype.hasOwnProperty.call(StFeatureFlagFlags, flagLabel)) {
      console.error(`Feature Flag is not mapped: ${flagLabel}`);
      return;
    }
    if (reporting.value && !alreadyShownFlagNotification[flagLabel] && !SENSITIVE_FLAGS.has(flagLabel)) {
      console.info(`Feature "${flagLabel}" is`, reporting.value);
      alreadyShownFlagNotification[flagLabel] = true;
    }
  },
});

/**
 * Show overrides locally, this is useful to test the featureflag
 * Uncomment the line above to test flags locally
 */
// StFeatureFlagController.showOverrides();

